import { Component } from '@angular/core';
import { LoggerService } from './services/logger.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Estimador';
  
  constructor(private logger: LoggerService) {
    // El nivel de log ahora se auto-configura dinámicamente dentro del propio 
    // LoggerService leyendo la Bóveda E2DB a través del AppConfigService.
    logger.info('LoggerService inicializado mediante Configuración E2DB.');
  }
}